const BACKEND_URL: string =
  process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:4041';

const BACKEND_PORT: string =
  process.env.REACT_APP_BACKEND_PORT ?? '4041';

export const API_BASE_URL: string = BACKEND_URL;
export const SOCKET_URL: string = BACKEND_URL;
export const BACKEND_PORT_NUMBER: number = parseInt(BACKEND_PORT, 10);
